import {
  loadNotExistingCompanyFieldIds,
  selectAllCompanies,
  selectAllProjectTypes,
  selectFieldsByCompany,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { CompanyId } from '@core/core/types'
import { useEffect } from 'react'

/**
 * Получаем справочники для редактирования свойств проекта
 * Месторождения соответствуют указанному ДО
 * @param companyId Выбранное ДО, для которого выводим месторождения
 */
export const useProjectDictionaries = (companyId?: CompanyId) => {
  const dispatch = useAppDispatch()

  // Месторождения и ДО грузятся при старте, тут догружаем нужные связи
  useEffect(() => {
    if (companyId) {
      dispatch(loadNotExistingCompanyFieldIds(companyId))
    }
  }, [companyId])

  const companies = useAppSelector(selectAllCompanies)
  const fields = useAppSelector(state => selectFieldsByCompany(state, companyId))
  const projectTypes = useAppSelector(selectAllProjectTypes)

  return { companies, fields, projectTypes }
}
